import React, { useState } from "react";
// import "./ReferAndEarn.css"; // move your CSS here
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { DataContext } from "../../src/context/DataProvider";
import { useContext } from "react";
import companyLogo from "../../src/assets/logo/logo.png";
import { useNavigate } from "react-router-dom";
import axiosMain from "../../src/axiosMain";
import Login from "../pages/Login";
import PaymentModal from "../pages/Payment/TopUpPayment";
import ViewPaymentHistory from "../pages/Payment/ViewPaymentHistory";
import { Button } from "react-bootstrap";
import ReferAndEarn from "../pages/ReferEarn/ReferAndEarn";
import { BASE_URLS } from "../utils/baseUrls";
import { format } from 'date-fns';
import walletCardBG from "../../src/assets/walletCard-bg.png";

// import Login from "../../src/";
// import ViewPaymentHistory from "../../Payment/ViewPaymentHistory";
// import PaymentModal from "../../Payment/TopUpPayment";

const Header = () => {
    const { showSideBar, isLoggingOut, setIsLoggingOut, clearDataContext, searchType, tenderGPTData, resultGPTData, setLoading ,isWalletPopupVisible, setIsWalletPopupVisible,} = useContext(DataContext);
    // const [showNotification, setShowNotification] = useState(false);
    // const [isVisible, setIsVisible] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0);
    const [walletBalanceInput, setwalletBalanceInput] = useState(null);
    const [topUpPaymentModal, setTopUpPaymentModal] = useState(false);
    const [objData, setObjData] = useState(null);
    const [viewPaymentModalIsOpen, setViewPaymentModalIsOpen] = useState(false);
    const [openModal, setopenModal] = useState(false);
    const [paymentHistory, setpaymentHistory] = useState(false);
    const [showModalReferAndEarn, setShowModalReferAndEarn] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);

const sidebarToggle = () => {
  setShowSidebar(prev => !prev);
};
    const navigate = useNavigate();
    const clickWalletBalanceChange = (val) => {
        setwalletBalanceInput(val);
    }
    const toggleWalletCard = async () => {
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            var parseLocalStorage = JSON.parse(localstoretoken);

        }
        await axiosMain
            .post(BASE_URLS + "/Wallet/GetWalletBalance",
                {
                    UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
                    UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
                    DomainId: parseLocalStorage === undefined ? 0 : parseLocalStorage.DomainId,
                    ItemId: 0,
                    CreatedBy: 0,
                    ResultAmount: 0.0,
                    TenderAmount: 0.0,
                    EMDAmount: 0.0,
                    ReferenceBy: null,
                    TenderProcId: null,
                    ReferenceId: null,
                    Bidderids: null,
                    Querydata: null,
                    SubNo: null,
                    Offset: 0,
                    PageSize: 0,
                    FilterStartDate: null,
                    FilterEndDate: null,
                    ItemPrice: 0.0,
                    TenderListFlag: 0,
                    ReferenceDetailId: null
                }
            )
            ?.then((res) => {
                if (res.data.StatusCode === 200) {
                    // res.data.TransactionCurrency
                    setWalletBalance(res.data.Data.WalletBalance);
                    // setIsVisible(!isVisible);
                    setIsWalletPopupVisible(prev => !prev);
                }

            })
            ?.catch((err) => console.log(err));

    };
    const handleTopUp = async () => {
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            var parseLocalStorage = JSON.parse(localstoretoken);
        }

        await axiosMain
            .post(BASE_URLS + "/UserPayment/GenerateOrderTopUp",
                {
                    PayEmail: parseLocalStorage === undefined ? "" : parseLocalStorage.Email,
                    // IpAddress: "192.168.101.21",
                    UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
                    UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
                    // DomainUrl: "tendertiger.co.in",
                    NewOrRenew: "New User",
                    TopUpAmount: parseFloat(walletBalanceInput),
                    OrderFlag: 1,
                    ReferenceBy: null,
                    TenderProcId: 0,
                    ReferenceId: 0,
                    ItemId: 0,
                    ItemPrice: 0.0
                }
            )
            ?.then((res) => {
                if (res.data.StatusCode === 200) {
                    setObjData(res.data);
                    // setIsVisible(!isVisible);
                    setIsWalletPopupVisible(prev => !prev);
                    setTopUpPaymentModal(true);
                    setwalletBalanceInput(null);
                }

            })
            ?.catch((err) => console.log(err));

    };
    const fnlogout = () => {
        localStorage.removeItem("logDetails");
        localStorage.removeItem("token");
        setIsLoggingOut(false);
        // clearDataContext();
    };
    const viewHistory = async () => {
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            var parseLocalStorage = JSON.parse(localstoretoken);
        }
        await axiosMain
            .post(BASE_URLS + "/wallet/GetWalletTransactionReport",
                {
                    UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
                    UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
                    DomainId: parseLocalStorage === undefined ? 0 : parseLocalStorage.DomainId,
                    ItemId: 0,
                    CreatedBy: 0,
                    ResultAmount: 0.0,
                    TenderAmount: 0.0,
                    EMDAmount: 0.0,
                    ReferenceBy: null,
                    TenderProcId: null,
                    ReferenceId: null,
                    Bidderids: null,
                    Querydata: null,
                    SubNo: null,
                    Offset: 0,
                    PageSize: 0,
                    FilterStartDate: "",
                    FilterEndDate: "",
                    ItemPrice: 0.0,
                    TenderListFlag: 0,
                    ReferenceDetailId: null
                }
            )
            ?.then((res) => {
                if (res.data.StatusCode === 200) {
                    setpaymentHistory(res?.data?.Data);
                }
                else if (res.data.StatusCode === 204) {
                    setpaymentHistory([]);
                }
                setViewPaymentModalIsOpen(true);

            })
            ?.catch((err) => console.log(err));

        setViewPaymentModalIsOpen(true);
    }
    const handleDateChangeApply = async (startDate, endDate) => {
        var parseLocalStorage;
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            parseLocalStorage = JSON.parse(localstoretoken);
        }
        await axiosMain
            .post(BASE_URLS + "/wallet/GetWalletTransactionReport",
                {
                    UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
                    UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
                    DomainId: parseLocalStorage === undefined ? 0 : parseLocalStorage.DomainId,
                    ItemId: 0,
                    CreatedBy: 0,
                    ResultAmount: 0.0,
                    TenderAmount: 0.0,
                    EMDAmount: 0.0,
                    ReferenceBy: null,
                    TenderProcId: null,
                    ReferenceId: null,
                    Bidderids: null,
                    Querydata: null,
                    SubNo: null,
                    Offset: 0,
                    PageSize: 0,
                    FilterStartDate:format(new Date(startDate), 'yyyy-MM-dd'),
                    FilterEndDate: endDate,
                    ItemPrice: 0.0,
                    TenderListFlag: 0,
                    ReferenceDetailId: null
                }
            )
            ?.then((res) => {
                if (res.data.StatusCode === 200) {

                    setpaymentHistory(res?.data?.Data);
                }
                else if (res.data.StatusCode === 204) {
                    setpaymentHistory([]);
                }
                setViewPaymentModalIsOpen(true);

            })
            ?.catch((err) => console.log(err));
    }


    return (
        <>
            <div className="nav-bar-style">
                <div className="logo-container main-header">
                    <span
                        className={
                            showSideBar
                                ? "company-chat-logo"
                                : "company-chat-logo-clospan"
                        }
                        onClick={() => navigate("/chat")}
                    >
                        <img src={companyLogo} className="ps-3 company-logo-style" />
                    </span>
                    <li className="menu" onClick={()=>sidebarToggle()}>
                            <i class="fa fa-bars"></i>
                            </li>
                    <div className={`right ${showSidebar ? "active" : ""}`}>
                    <li className="navbar-close" onClick={()=>sidebarToggle()}>
                            <i class="fa fa-times"></i>
                            </li>


                        <ul className="right-menu">


                            {localStorage.getItem("logDetails") !== null && (<><li className="nav-item showMyWallet nav-item-mywallet" onClick={toggleWalletCard}>

                                <div class="menu-item"><i class="fas fa-wallet"></i><span> My Wallet </span></div>

                                { isWalletPopupVisible && (
                                    <div className="sm-Wallet-card" id="walletCard" onClick={(e) => e.stopPropagation()} style={{
                                        backgroundImage: `url(${walletCardBG})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                      }}>
                                        <div className="sm-Wallet-card-">
                                            <div className="tt-wallet-card">
                                                <div className="card-footer">
                                                    <p>Available Points</p>
                                                    <h1 className="balance-amount" id="walletBalance">
                                                        {walletBalance}
                                                        <span className="tt-wallet-card-points"> Points</span>
                                                    </h1>
                                                </div>

                                                <div className="add-new-topup mt-2">
                                                    <div className="d-flex align-items-center">
                                                        <div className="input-group">
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Enter Amount"
                                                                aria-label="Enter Amount"
                                                                id="amountInput"
                                                                value={walletBalanceInput}
                                                                onChange={(e) => clickWalletBalanceChange(e.target.value)}
                                                            />
                                                            <button style={{ backgroundColor: '#353535', color: "white" }} className="btn top-up-button" type="button" onClick={handleTopUp}>
                                                                Top Ups
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Button variant="link" className="label-history" onClick={() => { viewHistory(); }}>
                                                    View History &gt;&gt;
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </li>
                                <li>
                                    <div className="menu-item" onClick={() => setShowModalReferAndEarn(true)}>
                                        <i className="fas fa-gift"></i>
                                        <span> Refer & Earn </span>
                                    </div>
                                </li>

                                <li>
                                    <div className="menu-item">
                                        <i className="fas fa-heart"></i>
                                        <span> Favorite </span>
                                    </div>
                                </li>

                                <li>
                                    <div className="menu-item">
                                        <i className="fas fa-shopping-bag"></i>



                                        <span> Order</span>
                                    </div>
                                </li></>)}
                            {/* <li>
                    <div className="menu-item"> <i className="fas fa-wallet"></i>

                      <span>20K</span>
                    </div>
                  </li> */}


                            <li>
                                <div className="login-btn">
                                    {isLoggingOut === true ? (
                                        <div className="menu-item" onClick={fnlogout} style={{ cursor: "pointer" }}> <i className="fa fa-sign-out-alt"></i>
                                            <span>Logout</span>
                                        </div>
                                    ) : (

                                        <div className="menu-item" onClick={() => setopenModal(true)} style={{ cursor: "pointer" }}> <i className="fa fa-sign-in-alt"></i>
                                            <span>Login</span>
                                        </div>

                                    )}
                                </div>
                            </li>

                         

                            <li className="d-none">
                                <div className="">
                                    <label htmlFor="theme-selector">Theme:</label>
                                    <select id="theme-selector">
                                        <option value="default">Default</option>
                                        <option value="dark">Dark</option>
                                        <option value="light">Light</option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <Login
                showModal={openModal}
                setopenModal={setopenModal}
                handleClose={() => setopenModal(false)}
            />
            <PaymentModal show={topUpPaymentModal} handleClose={() => setTopUpPaymentModal(false)} objData={objData} />
            <ViewPaymentHistory paymentModalIsOpen={viewPaymentModalIsOpen} handlePaymentModalClose={() => setViewPaymentModalIsOpen(false)} paymentData={paymentHistory} handleDateChangeApply={handleDateChangeApply} />
            <ReferAndEarn show={showModalReferAndEarn} handleClose={() => setShowModalReferAndEarn(false)} />

        </>
    );
};

export default Header;
